import { Component, OnInit, ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import { TableColumn, CommonTableService } from 'app/services/common-table.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { AppSettings } from 'app/app.settings';
import { AdminService } from 'app/services/admin.service';
import { UserService, CustomerType } from 'app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/services/auth.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { MatDialogConfig } from '@angular/material';
import { CommonFunctionService } from 'app/services/common-function.service';
import { AddUserModalComponent, AddUserModalOutput } from './add-user-modal/add-user-modal.component';
import { ConfirmModalData, ConfirmModalComponent } from 'app/components/modal/confirm-modal/confirm-modal.component';
import { IntegratorSelectComponent } from 'app/components/modal/integrator-select/integrator-select.component';
import { PaneControlService } from 'app/services/pane-control.service';

@Component({
  selector: 'app-config-users',
  templateUrl: './config-users.component.html',
  styleUrls: ['./config-users.component.css']
})
export class ConfigUsersComponent implements OnInit, AfterViewInit {

	@ViewChild('roleTempl', { static: false }) roleTempl: TemplateRef<any>;
	@ViewChild('operationsTempl', { static: false }) operationsTempl: TemplateRef<any>;
	@ViewChild('userEmailTempl', { static: false }) userEmailTempl: TemplateRef<any>;

	// rows without filter
	public unfilteredRows: any[] = []
	//
	public rows: any[] = [];
	public columns: TableColumn[] = [];
	public selectedRows = [];

	public searchStr = '';
	// Is user a administrator
	public isAdmin: boolean;
	public customerType: CustomerType;

	// newUser object is created as the new-user-email's ngModel binding. Not using row[userEmailCol] because:
	// The input in ngx-datatable will lose focus on typing somehow...
	public newUser = {
		email: ''
	};
	// The name of the property to check new user
	public isNewUserCol = 'isNewUser';
	//
	public readonly userEmailCol = 'userEmail';
	public readonly roleCol = 'userRole';
	private readonly originalRoleCol = 'originalRole';
	private readonly operationsCol = 'operations';
	private readonly usbIdCol = 'usbId';
	constructor(
		private toastr: ToastrService,
		private adminService: AdminService,
		private appinfoService: AppinfoService,
		private authService: AuthService,
		private commonService: CommonFunctionService,
		private tableService: CommonTableService,
		private modalService: CommonModalService,
		private paneService: PaneControlService,
		private userService: UserService
	) { }

	public onSelectRow() {}
	public onChangeNewUserEmail() {
		console.log('hhhhhh')
	}
	public async onChangeRole(row) {
		if (!row[this.isNewUserCol]) {
			const role = this.appinfoService.rolesByApp[AppSettings.appName].find((r) => r.desc === row[this.roleCol]);
			if (role) {
				try {
					await this.adminService.updateUserSubscription(row.usbId, role.rol_id);
					this.toastr.success('Successfully updated.');
				} catch (err) {
					this.toastr.error('Failed to update user role.');
				}
			}
		}
	}
	public async addUser() {
		const options: MatDialogConfig = {
			width: '550px',
			height: '250px'
		};
		const result: AddUserModalOutput = await this.modalService.openModalWindow(AddUserModalComponent, options);
		if (result) {
			if (result.roleDesc === 'INTEGRATOR' && !this.userService.getUserInfo().isAdmin) {
				this.toastr.warning('Integrator can be invited only by administrator');
				return;
			}
			this.commonService.setLoadingSpinner(true);
			try {
				let userId;
				// an INTEGRATOR user may exist already
				if (result.roleDesc === 'INTEGRATOR') {
					userId = await this.adminService.checkUserExist(result.email);
				}
				if (!userId) {
					// Add user to database
					const rsp: any = await this.adminService.addUser(result.email);
					userId = rsp.data[0].usr_id;
					// Send new user a confirmation email
					await this.authService.inviteUser(result.email);
					this.toastr.success('An email has been sent to the user for verification.');
				} else {
					// Send existing user an email notification
					// TODO!!!


				}
				// Add user subscriptions to new user
				try {
					await this.adminService.addUserSubscription(userId, this.userService.getUserInfo().subscriptionId, result.roleId);
					// Update admin // TODO
					await this.adminService.updateUserAdmin(true, result.email);
					// Update users
					await this.updateTable();
				} catch (err) {
					console.log(err);
					this.toastr.error('Failed to add user subscription');
				}
			} catch (err) {
				this.toastr.error(err.message);
			}
			this.commonService.setLoadingSpinner(false);
		}
		// if (!this.newUser.email) {
		// 	return;
		// }
		// try {
		// 	// Add user to database
		// 	const rsp: any = await this.adminService.addUser(this.newUser.email);
		// 	// Send new user a confirmation email
		// 	await this.authService.inviteUser(this.newUser.email);
		// 	this.toastr.success('An email has been sent to the user for verification.');
		// 	// Add user subscriptions to new user
		// 	try {
		// 		const role = this.appinfoService.rolesByApp[AppSettings.appName].find((r) => r.desc === row[this.roleCol]);
		// 		await this.adminService.addUserSubscription(rsp.data[0].usr_id, this.userService.getUserInfo().subscriptionId, role.rol_id);
		// 		// Update users
		// 		await this.updateTable();
		// 	} catch (err) {
		// 		console.log(err);
		// 		this.toastr.error('Failed to add user subscription');
		// 	}
		// } catch (err) {
		// 	this.toastr.error(err.message);
		// }
	}
	public async removeUser(row) {
		// Not allow deleting self
		if (row[this.userEmailCol] === this.userService.getUserInfo().userEmail) {
			this.toastr.info('You cannot delete yourself!');
			return;
		}
		// Confirm
		const options = this.modalService.confirmModalOptions;
		const data: ConfirmModalData = {
			message: 'Are you sure you want to delete this user: ' + row[this.userEmailCol] + '?'
		};
		options.data = data;
		const result = await this.modalService.openModalWindow(ConfirmModalComponent, options);
		// Deleting
		if (result) {
			try {
				await this.adminService.deleteUser(row[this.userEmailCol]);
				await this.updateTable();
				this.toastr.success('The user has been deleted successfully.');
			} catch (err) {
				this.toastr.error('Failed to delete the user.');
			}
		}
	}
	public search() {
		this.rows = this.filterRows();
	}
	public async pickIntegrator() {
		const options: MatDialogConfig = {
			width: '550px',
			height: '450px'
		};
		const result: AddUserModalOutput = await this.modalService.openModalWindow(IntegratorSelectComponent, options);
		if (result) {

		}
	}

	private async updateTable() {
		const userSubs = await this.adminService.getUserSubscription();
		const rows = [];
		userSubs.forEach((usb) => {
			const row: any = {};
			row[this.userEmailCol] = usb.userEmail;
			row[this.roleCol] = usb.role;
			row[this.originalRoleCol] = usb.role;
			row[this.usbIdCol] = usb.userSubId;
			rows.push(row);
		});
		// Add new user row
		const newUserRow: any = {};
		newUserRow[this.isNewUserCol] = true;
		newUserRow[this.userEmailCol] = '';
		newUserRow[this.roleCol] = this.appinfoService.rolesByApp[AppSettings.appName][0].desc;
		newUserRow[this.originalRoleCol] = newUserRow[this.roleCol];
		rows.push(newUserRow);
		this.unfilteredRows = rows;
		this.rows = this.filterRows();
	}
	// Filter rows with searchStr
	private filterRows() {
		if (this.searchStr) {
			return this.unfilteredRows.filter((r) => {
				// Always show newUserRow
				if (r[this.isNewUserCol]) {
					return true;
				}
				if (r[this.userEmailCol]) {
					return r[this.userEmailCol].toLowerCase().indexOf(this.searchStr.toLowerCase()) > -1
				}
				return false;
			});
		} else {
			return this.unfilteredRows;
		}
	}
	// Set table columns
	private setColumns() {
		const columns = [];
		// Add user name column
		const userEmailCol = this.tableService.setNewColumn(this.userEmailCol, 'User Name', {
			skipGdoCheck: true,
			// width: 200,
			// cellTemplate: this.userEmailTempl,
			isNameKeepCase: true
		});
		columns.push(userEmailCol);
		// Add role columns
		const roles = this.appinfoService.rolesByApp[AppSettings.appName];
		roles.forEach((r) => {
			const col = this.tableService.setNewColumn(r.desc, null, {
				align: 'C',
				skipGdoCheck: true,
				cellTemplate: this.roleTempl,
				isNameKeepCase: true
			});
			columns.push(col);
		});
		// Add operations column
		const operationsCol = this.tableService.setNewColumn(this.operationsCol, 'Add/Remove', {
			align: 'C',
			skipGdoCheck: true,
			cellTemplate: this.operationsTempl,
			isNameKeepCase: true
		});
		columns.push(operationsCol);
		this.columns = columns;
	}
	
	ngOnInit() {
		// Tell paneControl current pane is switched to config, so that the highlighted menu item can change to config
		this.paneService.currPane.next({
			paneType: 'config',
			submenu: 'configUsers'
		});
		this.isAdmin = this.userService.getUserInfo().isAdmin;
		this.customerType = this.userService.customerInfo.type;
	}
	ngAfterViewInit(): void {
		this.setColumns();
		this.updateTable();
	}

}
